var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"tab-btns border-0 btn-outline-none bg-white text-medium-gray fs-12 py-9 px-32 position-relative text-center w-100",class:[_vm.tabActive == _vm.id?'tab-active':'tab-inactive'],on:{"click":function($event){return _vm.handleTabClick(_vm.id)}}},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }